export function getCountSummaryURL(): string {
	return '/authenticated/data/counts';
}
